/**
 * Errores tipados del flujo de invitación de tenant (LION-864).
 *
 * `TenantInvitationService.accept()` los lanza para que la pantalla pública
 * pueda ramificar la UI sin parsear status codes: la política de contraseña
 * (400 WEAK_PASSWORD) se renderiza inline con sus violaciones (reutiliza
 * `PasswordPolicyError`); el token inválido (401) muestra el aviso genérico; y
 * el throttling (429) avisa para reintentar más tarde.
 */

/**
 * La invitación falta, expiró, ya se usó o el token es inválido (HTTP 401,
 * `INVALID_TENANT_INVITATION`). Nunca se revela cuál: la UI muestra un único
 * aviso genérico (anti-enumeración, mismo criterio que el reset de contraseña).
 */
export class InvalidTenantInvitationError extends Error {
  constructor() {
    super('El enlace no es válido o expiró.');
    this.name = 'InvalidTenantInvitationError';
  }
}

/** Throttling del endpoint público (HTTP 429): reintentar en unos minutos. */
export class TooManyInvitationAttemptsError extends Error {
  constructor() {
    super('Demasiados intentos, probá de nuevo en unos minutos.');
    this.name = 'TooManyInvitationAttemptsError';
  }
}
